import React from "react";

import { LineChart } from "@mui/x-charts/LineChart";

import { useIndicators } from "../../hooks/useIndicators";
import { useWidgetFetch } from "../../hooks/useWidgetFetch";
import { RendererProps } from "./types";

export const LineWidget = (props: RendererProps) => {
  const { data, isLoading, error } = useWidgetFetch(props.config.title, props.config.dataSource, props.optionValues);

  const { config } = props;

  const someIndicatorView = useIndicators(props, isLoading, error);
  if (someIndicatorView) {
    return someIndicatorView;
  }

  const nSeries = data[0] ? Object.keys(data[0]).length - 1 : 0;

  const seriesData = new Array(nSeries).fill({}).map((_, index) => ({
    data: data.map((item: any) => item[index + 1]),

    label: nSeries > 1 ? (config.columns && config.columns[index].name) || `Series ${index + 1}` : undefined,
  }));

  return (
    <LineChart
      colors={props.colors}
      xAxis={[
        {
          scaleType: "band",
          data: data.map((item: any) => item[0]),
        },
      ]}
      series={seriesData}
      height={400}
    />
  );
};
